import { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";

const STORAGE_KEY = "netbasis_cookie_acknowledged";

export default function CookieBanner() {
  const { t, i18n } = useTranslation("home");
  const [visible, setVisible] = useState(false);
  const [closing, setClosing] = useState(false);

  useEffect(() => {
    const acknowledged = localStorage.getItem(STORAGE_KEY);
    if (!acknowledged) {
      // Small delay for entrance animation
      const timer = setTimeout(() => setVisible(true), 300);
      return () => clearTimeout(timer);
    }
  }, []);

  const handleClose = () => {
    setClosing(true);
    setTimeout(() => {
      localStorage.setItem(STORAGE_KEY, "true");
      setVisible(false);
    }, 300);
  };

  if (!visible) return null;

  // Determine privacy page URL based on current language
  const privacyUrl =
    i18n.language === "de"
      ? "/de/datenschutz"
      : i18n.language === "fr"
        ? "/fr/politique-de-confidentialite"
        : i18n.language === "es"
          ? "/es/politica-de-privacidad"
          : "/en/privacy";

  return (
    <div
      className={`fixed bottom-0 left-0 right-0 z-[60] transition-transform duration-300 ${
        closing ? "translate-y-full" : "translate-y-0"
      }`}
    >
      <div className="bg-white border-t border-background-200 shadow-[0_-4px_20px_rgba(0,0,0,0.06)]">
        <div className="max-w-[1100px] mx-auto px-4 md:px-6 lg:px-8 py-4 md:py-5">
          <div className="flex flex-col sm:flex-row items-start sm:items-center gap-4">
            <div className="flex-1">
              <p className="font-body text-sm md:text-base text-foreground-700 leading-relaxed">
                {t("cookie_banner.text")}{" "}
                <Link
                  to={privacyUrl}
                  className="text-primary-600 hover:text-primary-700 underline whitespace-nowrap cursor-pointer"
                >
                  {t("cookie_banner.privacy_link")}
                </Link>
              </p>
            </div>
            <button
              onClick={handleClose}
              className="px-6 py-2.5 bg-primary-500 hover:bg-primary-600 text-white font-label text-sm font-semibold rounded-md transition-colors cursor-pointer whitespace-nowrap flex-shrink-0"
            >
              {t("cookie_banner.button")}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}